/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when a handler could not be unsubscribed
 * @export
 * @class ModelCouldNotUnsubscribeError
 * @extends {Error}
 */
export class ModelCouldNotUnsubscribeError extends Error {
  /**
   * Creates an instance of ModelCouldNotUnsubscribeError
   * @param {string} message The Error `message`
   * @memberof ModelCouldNotUnsubscribeError
   */
  constructor(message) {
    super(message);
    this.name = `ModelCouldNotUnsubscribeError`;
  }
}

/**
 * Called when a handler could not be unsubscribed
 * @param {string} name The name of the handler
 * @returns {never} never
 */
const throwModelCouldNotUnsubscribeError = (name) => {
  throw new ModelCouldNotUnsubscribeError(
    stripIndent(`
    Could not unsubscribe "${name}". Handler not found.
    Have you already called "unsubscribe()"?
    `),
  );
};

export default throwModelCouldNotUnsubscribeError;
